<style scoped>
.svgContent {
  width: 100%;
  text-align: center
}
.icon-search {
  position: fixed;
  top: 120px;
  left: 2px;
  z-index: 999;
}
.searchBox {
  position: fixed;
  width: 200px;
  padding: 10px;
  background-color: #fff;
  height: auto;
  top: 100px;
  left: 0px;
  border: 1px solid #ccc;
  border-radius: 5px;
  z-index: 100;
}
.icon-close {
  position: absolute;
  top: 20px;
  left: 198px;
  cursor: pointer;
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  background-color: #fff;
  border-radius: 0 5px 5px 0;
}
</style>

<template>
  <div>
    <div class="icon-search" v-show="!searchBoxShow">
        <Button type="warning" shape="circle" icon="ios-search" @click="switchSearchBox(false)"></Button>
    </div>
    <transition name="fade">
      <div class="searchBox" v-show="searchBoxShow">
        <div class="icon-close" @click="switchSearchBox(true)">
          <Icon type="md-close" :size="18" color="gray" />
        </div>

        <h3 class="text-center">地铁站点路径图</h3>
        <Divider style="margin: 10px 0;"/>
        <Row class="p-b-10">
          <i-col span="8" class="p-l-5 p-t-5"><h3>城市：</h3> </i-col>
          <i-col span="16">
            <Select v-model="chooseCity" prefix="ios-home" @on-change="handleChangeCity">
              <OptionGroup v-for="(group,index) in cityGroup" :key="index" :label="group">
                  <Option v-for="city in citys.filter(x=>x.group === group)" :value="city.code" :key="city.code">{{ city.name }}</Option>
              </OptionGroup>
            </Select>
          </i-col>
        </Row>

        <Row class="m-b-10">
          <i-col span="24">
            <Input v-model="stations" type="textarea" :rows="15" placeholder="按顺序输入所有需要经过的站点名称，站点之间以‘,’分隔" />
          </i-col>
        </Row>

        <Row class="m-b-10">
          <i-col span="24">
            <Button :icon="pause? 'md-pause' : 'md-play'" long type="primary" @click="handlePause">{{pause?'暂停':'播放'}}路劲</Button>
          </i-col>
        </Row>
      </div>
    </transition>

    <div v-html="svgHtml" id="svgWorkPlatform" class="svgContent"></div>

    <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
        <div>地图加载中...</div>
    </Spin>
  </div>
</template>

<script>
import { mapOperation } from '@/utils/mapOperation'

import { getAllByCityCode } from '@/api/rim'

export default {
  mixins: [mapOperation], // 混入地图操作的方法
  data () {
    return ({
      svgHtml: '',
      chooseCity: '', // 默认选中城市
      citys: this.$store.state.main.mapCitys,
      cityGroup: [],

      spinShow: false,
      searchBoxShow: true,

      stations: '西红门，高米店北，高米店南，枣园，清源路，黄村西大街，黄村火车站，义和庄',
      stationIds: [158, 157, 156, 155, 154, 153, 152, 151],
      pause: false
    })
  },
  mounted () {
    this.formatCityData()
    this.initPageData()
    // 设置中间区域地图高度
    this.$nextTick(() => {
      document.getElementById('svgWorkPlatform').style.height = document.documentElement.clientHeight - 50 + 'px'
    })
  },
  methods: {
    formatCityData () {
      this.chooseCity = this.citys[0].code
      let group = []
      this.citys.forEach(element => {
        if (group.indexOf(element.group) === -1) {
          group.push(element.group)
        }
      })
      this.cityGroup = group.sort()
    },
    initPageData () {
      const data = { cityCode: this.chooseCity }
      getAllByCityCode(data).then(res => {
        this.linePoint = res
      })

      // 调用mixins方法
      this.initMap()
    },
    handleChangeCity () {
      this.pause = false
      this.initPageData()
    },
    switchSearchBox (show) {
      this.searchBoxShow = !show
    },
    handlePause () {
      this.pause = !this.pause
      const _self = this

      if (this.pause) {
        // 标注起始点, 并用动画过度到当前点位
        const formatStations = [{
          stationId: this.stationIds[0],
          quantity: null
        }]

        this.loadResourceStations(formatStations, this.stationIds[0].toString(), false)

        setTimeout(function () {
          _self.beginPlayAnimation(0)
        }, 1000)
      }
    },
    beginPlayAnimation (flag) {
      // 标注起点
      const _self = this
      if (flag < this.stationIds.length) {
        const formatStations = [{
          stationId: this.stationIds[flag],
          quantity: null
        }]
        _self.loadResourceStations(formatStations, this.stationIds[flag].toString(), false)
        // _self.moveMarker(this.stationIds[flag], this.stationIds[flag + 1])
        setTimeout(function () {
          _self.beginPlayAnimation(flag + 1)
        }, 500)
      } else {
        // 停止调用事件， 将暂停键变更为播放键
        this.pause = false
      }
    },
    moveMarker (startStationId, endStationId) {
      this.handleMoveMarkerCenterByStation(startStationId, endStationId)
    }
  },
  destroyed () {
    // 页面销毁后， 不再继续执行自动播放
    this.pageDestroyed = true
  }
}
</script>
